import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import VolumeIcon from '../assets/volume-icon.svg?react';
import MuteIcon from '../assets/mute-icon.svg?react';

const Button = styled.button`
    ${({ theme }) => css`
        display: inline-flex;
        align-items: center;
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 4px;
        padding: 0;

        &::-moz-focus-inner {
            border: 0;
        }

        &:focus {
            box-shadow: ${theme.shadows['outline']};
        }

        &:active {
            box-shadow: none;
        }

        & > svg {
            fill: ${theme.colors['myzanichelli-blue-light']};
            width: 18px;
            height: 18px;
        }

        & > svg:hover {
            fill: ${theme.colors['myzanichelli-blue-dark']};
        }

        & > div.icon:hover {
            background-color: var(--blue700);
        }
    `}
`;

const VolumeButton = ({ onClick, hasVolume = true, ariaLabel, ariaControls }) => {
    return (
        <Button onClick={onClick} onMouseUp={(event) => event.target.blur()} aria-label={ariaLabel} aria-controls={ariaControls}>
            {hasVolume ? <VolumeIcon /> : <MuteIcon />}
        </Button>
    );
};

VolumeButton.propTypes = {
    onClick: PropTypes.func,
    hasVolume: PropTypes.bool,
    ariaLabel: PropTypes.string.isRequired,
    ariaControls: PropTypes.string.isRequired,
};

export default VolumeButton;
